import Component from '../Component';

export default class VerificationPopup extends Component {

  constructor(theme, element) {
    super(theme, element);

    // Age verification configuration
    this.ageTestMode = this.element.dataset.ageTestMode === 'true';
    this.ageSkipDays = parseInt(this.element.dataset.ageTime, 10);
    this.ageDelay = 0;

    // Cache DOM element references for modal interactions
    this.modalLinks = element.querySelector('.modal-content__wrapper a');
    this.enterButton = element.querySelector('#button__enter');
    this.exitButton = element.querySelector('#button__exit');
    this.returnButton = element.querySelector('#button__return');

    // Initialize the verification popup
    this.load();
  }

  /**
   * Read a cookie value by name
   * @param {string} name - The name of the cookie to read
   * @returns {string|null} The cookie value or null if not found
   */
  readCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0 ; i < ca.length ; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  /**
   * Retrieve modal content elements for state changes
   */
  getModalContent = () => {
    this.changeContent = document.querySelector('.modal-deny-content');
    this.hideInitial = document.querySelector('.modal-initial-content');
  }

  /**
   * Shared method to reset scroll position and retrieve modal content
   */
  resetScrollAndGetContent = () => {
    const prompt = document.getElementById('verification__prompt');
    if (prompt) {
      prompt.scrollTop = 0;
    }
    this.getModalContent();
  }

  /**
   * Write the age verification cookie and hide the modal
   */
  writeCookie = () => {
    document.cookie = "isAnAdult=true; expires=0; path=/";
    this.hideModal();
  }

  /**
   * Display the verification modal and trap focus within it
   */
  showModal = () => {
    const container = document.querySelector('.verification-popup-container');
    if (container) {
      container.style.display = 'block';
    }
    this.trapFocus();
    document.body.style.overflow = "hidden";
  }

  /**
   * Hide the verification modal and restore body scroll
   */
  hideModal = () => {
    const container = document.querySelector('.verification-popup-container');
    if (container) {
      container.style.display = 'none';
    }
    document.body.style.overflow = '';
  }

  /**
   * Trap keyboard focus within the modal for accessibility
   * Ensures users can't tab outside the modal while it's open
   */
  trapFocus = () => {
    setTimeout(() => {
      const container = document.querySelector('.verification-popup-container');
      if(container) {
        const focusableElements = container.querySelectorAll('button, a');
        const visibleElements = Array.from(focusableElements).filter(el => el.offsetParent !== null);
        const firstInput = visibleElements[0];
        const lastInput = visibleElements[visibleElements.length - 1];

        // Set focus on first input
        firstInput.focus();

        // Redirect last tab to first input
        lastInput.addEventListener('keydown', function (e) {
          if ((e.which === 9 && !e.shiftKey)) {
            e.preventDefault();
            firstInput.focus();
          }
        });

        // Redirect first shift+tab to last input
        firstInput.addEventListener('keydown', function (e) {
          if ((e.which === 9 && e.shiftKey)) {
            e.preventDefault();
            lastInput.focus();
          }
        });
      }
    }, 250);
  }

  /**
   * Switch modal to show the initial age confirmation content
   */
  confirmAgeModal = () => {
    this.resetScrollAndGetContent();
    this.changeContent.classList.add('hidden');
    this.hideInitial.classList.remove('hidden');
    this.trapFocus();
  }

  /**
   * Switch modal to show the "come back later" denial content
   */
  comeBackModal = () => {
    this.resetScrollAndGetContent();
    this.changeContent.classList.remove('hidden');
    this.hideInitial.classList.add('hidden');
    this.trapFocus();
  }

  /**
   * Initialize the verification popup and set up event listeners
   */
  load = () => {

    // Age checker is in test mode - will show immediately in editor and on live site
    if(this.ageTestMode) this.showModal();

    // Make modal links accessible via tab key
    if(this.modalLinks) {
      this.modalLinks.setAttribute('tabindex', '1');
    }

    // Check if user has already verified their age
    var isAnAdult = this.readCookie('isAnAdult');
    if (!isAnAdult) {
      if (window.Shopify.designMode && !this.ageTestMode) return;
      this.showModal();
    }

    // Set up button event listeners
    if(this.enterButton) {
      this.enterButton.addEventListener('click', this.writeCookie);
    }

    if(this.exitButton) {
      this.exitButton.addEventListener('click', this.comeBackModal);
    }

    if(this.returnButton) {
      this.returnButton.addEventListener('click', this.confirmAgeModal);
    }
  }
}
